export default "__VITE_ASSET__rm62C4fN__"